export default __webpack_public_path__ + "media/9d57286098b5291ed8b9f74abf709f1f1afffda30d1e273e023e2be963fb2089.svg";